import React, { ReactNode, RefObject } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Field, Form, FormSpy } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import TextInput from '../../common/inputs/TextInput';
import Button from '../../common/Button';
import logo from '../../../img/createAccount/pli_scelle.svg';
import Modal from '../../common/modals/Modal';
import { CONTACT_PAGE } from '../../../routes';
import { ActivationDTO } from '../../../network/api/types/activation/ActivationDTO';
import activationApi from '../../../network/api/activationApi';
import DateInput from '../../common/inputs/DateInput';

type Props = RouteComponentProps & {
  divRef: RefObject<HTMLDivElement>;
  update: (values: ActivationDTO) => void;
  onChange: (index: number) => void;
  initial: ActivationDTO;
};

type State = {
  isModalOpen: boolean,
};

class ActivationIds extends React.Component<Props, State> {
  state: State = {
    isModalOpen: false,
  };

  handleEdit = async (formValues): Promise<{ [FORM_ERROR]: string }> => {
    try {
      const split = formValues.birthDate.split('-');
      let values = {
        ...formValues,
        dayBirthday: split[2],
        monthBirthday: split[1],
        yearBirthday: split[0],
      };

      return activationApi.isIdsValid(values)
        .then((response) => {
          values = {
            ...values,
            pseudo: response.message,
          };
          this.props.update(values);
        })
        .catch((err) => {
          if (typeof err.then === 'function') {
            return err.then((e) => {
              if (e.fieldErrors[0].errorCode === 'RECU_01_MSG_02') {
                return { [FORM_ERROR]: 'Les informations saisies n\'ont pas permis d\'identifer votre compte à activer. Veuillez vérifier qu\'elles correspondent aux informations inscrites dans le courrier.' };
              }
              return { [FORM_ERROR]: e.fieldErrors[0].message };
            });
          }
          return null;
        });

      // const json = await
      // return { [FORM_ERROR]: '' };
    } catch (err) {
      return { [FORM_ERROR]: 'fal fa-exclamation-circle' };
    }
  };

  openModal = () => {
    this.setState((previousState) => ({ isModalOpen: !previousState.isModalOpen }));
  };

  render(): ReactNode {
    return (
      <div ref={this.props.divRef} className="account-activation-form-container">
        <div className="account-activation-col">
          <h3>
            <Translate value="ACTIVATION.ENTER_ID" />
          </h3>
        </div>
        <div className="account-activation-col">
          <Form
            onSubmit={this.handleEdit}
            initialValues={{
              id: null,
              initCode: null,
              birthDate: null,
            }}
            // validate={(values) => ({})}
            render={(
              {
                handleSubmit,
                submitError,
                values,
                submitting,
              },
            ) => (
              <form className="connection-information-form" onSubmit={handleSubmit}>
                <FormSpy
                  subscription={{ values: true, pristine: true, initialValues: true }}
                  onChange={(state) => {
                    if (state.values.id !== state.initialValues.id
                      || state.values.initCode !== state.initialValues.initCode
                      || state.values.birthDate !== state.initialValues.birthDate
                    ) {
                      this.props.onChange(0);
                    }
                  }}
                />
                {submitError && <div className="error">{submitError}</div>}
                <Field
                  name="id"
                  component={TextInput}
                  placeholder={I18n.t('ACTIVATION.ACTIVATION_ID')}
                  type="text"
                  required
                  limit={12}
                  minLength={12}
                  autoComplete="off"
                />
                <Field
                  name="initCode"
                  component={TextInput}
                  placeholder={I18n.t('ACTIVATION.ACTIVATION_CODE')}
                  type="text"
                  autoComplete="off"
                  required
                />
                <Field
                  name="birthDate"
                  component={DateInput}
                  placeholder={I18n.t('ACTIVATION.BIRTHDATE')}
                  type="text"
                  fieldType="date"
                  required
                />
                <Button
                  type="fifth"
                  onClick={() => this.openModal()}
                  i18nKey="ACTIVATION.NO_LETTER"
                />
                <div className="button-container">
                  <Button
                    type="primary"
                    buttonType="submit"
                    i18nKey="actions.NEXT"
                    isLoading={submitting}
                    disabled={values.id === null
                        || values.initCode === null || values.birthDate === null}
                  />
                </div>
              </form>
            )}
          />
        </div>
        <div className="account-activation-col">
          <div>
            <img className="logo" src={logo} alt="logo" />
          </div>
          <Translate value="ACTIVATION.LETTER" />
        </div>
        <Modal isOpen={this.state.isModalOpen} onClose={this.openModal}>
          <h3>
            <Translate value="ACTIVATION.NO_LETTER" />
          </h3>
          <div className="information-text">
            <Translate className="" value="NO_LETTER.POPIN_TEXT" />
            <Translate value="NO_LETTER.POPIN_SUBTEXT" />
          </div>
          <div className="button-container">
            <Button
              type="third"
              onClick={() => this.openModal()}
              i18nKey="actions.BACK"
            />
            <Button
              type="primary"
              onClick={() => this.props.history.push(CONTACT_PAGE)}
              i18nKey="NO_LETTER.ACTION"
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(ActivationIds);
